import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { AccessLevel, PermissionsGroup, Profile } from "PFTypes";
import { useMemo } from "react";

const useIsAvailabilityPermitted = (
  profile: Profile | null = null,
  accessLevel: AccessLevel[] = [AccessLevel.ReadWrite, AccessLevel.ReadOnly],
  permissionsGroup: PermissionsGroup | null = null
) => {
  const { data: currentProfile } = useCurrentProfile();

  const selectedProfile = profile || currentProfile;

  const availabilityPermissions = useMemo(() => {
    const internalPermissionsGroup = permissionsGroup || selectedProfile.permissionsGroup || {};

    return accessLevel.includes(
      (internalPermissionsGroup.crossGroupPermissions ||
        currentProfile.permissionsGroup.crossGroupPermissions ||
        // @ts-ignore
        {})[internalPermissionsGroup.id]?.profileFieldsAccessLevels?.availability
    );
  }, [profile, currentProfile]);

  return availabilityPermissions;
};

export default useIsAvailabilityPermitted;
